import axios from 'axios';

const axiosInstance = axios.create();

export default axiosInstance;